import { render, staticRenderFns } from "./CreateDevolucao.vue?vue&type=template&id=2efbabfd"
import script from "./CreateDevolucao.vue?vue&type=script&lang=js"
export * from "./CreateDevolucao.vue?vue&type=script&lang=js"
import style0 from "./CreateDevolucao.vue?vue&type=style&index=0&id=2efbabfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports